import type { ReactNode } from "react";

type Props = {
	description?: string;
	children: ReactNode;
	title?: string;
};

const PageContainer = ({ children }: Props) => (
	<div className="bg-background min-h-screen">{children}</div>
);

export default PageContainer;
